import LogUtil from '@/core/utils/logUtil'

export default class Pie {
    private _startAngle: number;
    private _angle: number;
    public radius: number;
    public centerx: number;
    public newSector: SVGPathElement;
    public finalTransform: any;

    get startAngle() {
        return this._startAngle;
    }

    set startAngle(value) {
        this._startAngle = value;
    }


    get angle() {
        return this._angle;
    }

    set angle(value) {
        this._angle = value;
        this.drawTo(value);
    }

    constructor(target, style, centerx, radius) {

        this._angle = -180;
        this._startAngle = 0;
        this.radius = radius;
        this.centerx = centerx;
        this.newSector = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.newSector.setAttributeNS(null, 'class', style);

        try {

            target.insertBefore(this.newSector, target.querySelector('g'));
        }
        catch (e) {
            LogUtil.error('ERROR', e);
        }
    }

    drawTo(to) {
        this.drawFromTo(this.startAngle, to)
    }

    drawFromTo(from, to) {

        let a = to;
        let x = 0;
        let Y = 0;
        let X = 0;
        let arcSweep = 0;
        let R = from - 90;

        let h = this.centerx - this.radius;
        let l = this.radius;

        a = 180 - a * (-1);
        let aCalc = ( a > 180 ) ? 360 - a : a;
        let aRad = aCalc * Math.PI / 180;
        let z = Math.sqrt(2 * l * l - ( 2 * l * l * Math.cos(aRad) ));
        if (aCalc <= 90) {
            x = l * Math.sin(aRad);
        }
        else {
            x = l * Math.sin((180 - aCalc) * Math.PI / 180);
        }

        let y = Math.sqrt(z * z - x * x);
        Y = y;

        if (aCalc <= 180) {
            X = l + x;
            arcSweep = 0;
        }
        else {

            X = l - x;
            arcSweep = 1;
        }


        let sector = {
            arcSweep: arcSweep,
            L: l,
            X: X,
            Y: Y,
            R: R
        };
        this.finalTransform = {
            translate: [h, h],
            rotate: [sector.R, sector.L, sector.L]
        }
        this.newSector.setAttributeNS(null, 'd', 'M' + sector.L + ',' + sector.L + ' L' + sector.L + ',0 A' + sector.L + ',' + sector.L + ' 0 ' + sector.arcSweep + ',1 ' + sector.X + ', ' + sector.Y + ' z');
        this.newSector.setAttributeNS(null, 'transform', `translate(${ this.finalTransform.translate.join(", ") }) rotate(${ this.finalTransform.rotate.join(", ") })`);
    }
}
